export const ROUTE_PATH = '/parking-whitelist-group/create';

export const FEATURE_NAME = 'parkingWhitelistDynamicFilterPage';
